import React from 'react';

import Hero from '../../presentational/Hero';

function HeroContainer(props) {
  return (
    <Hero className="" link="p-peel-intro">
      <div id="ppeel-header">
        <h1><em>The Ultimate</em></h1>
        <p><em>Treat</em> for all Skin Types</p>
      </div>
    </Hero>
  )
}

export default HeroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/ppeel/HeroContainer.jsx
 **/